module.exports = __webpack_public_path__ + "img/Jd.c915eb3a.png";